/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import type {
  AiRealtimeSessionToken
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create Realtime Session Token
 */
export const createAiRealtimeSession = (

 signal?: AbortSignal
) => {


      return axiosClient<AiRealtimeSessionToken>(
      {url: `/ai/realtime_sessions`, method: 'POST', signal
    },
      );
    }




export const getCreateAiRealtimeSessionMutationKey = () => ['createAiRealtimeSession'] as const;

export const getCreateAiRealtimeSessionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiRealtimeSession>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiRealtimeSession>>, TError,void, TContext> => {

const mutationKey = getCreateAiRealtimeSessionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiRealtimeSession>>, void> = () => {


          return  createAiRealtimeSession()
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiRealtimeSessionMutationResult = NonNullable<Awaited<ReturnType<typeof createAiRealtimeSession>>>

    export type CreateAiRealtimeSessionMutationError = ErrorType<void>


    /**
 * @summary Create Realtime Session Token
 */
export const useCreateAiRealtimeSession = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiRealtimeSession>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiRealtimeSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getCreateAiRealtimeSessionMutationOptions(options), queryClient);
    }
